import React, { useState } from 'react';
import { ArrowRight, X, Plus, ShieldCheck } from 'lucide-react';
import { type Product } from './shopData';
function Seal({
  label
}: {
  label: string;
}) {
  return <div className="w-[72px] h-[72px] rounded-full border-2 border-white/70 flex flex-col items-center justify-center text-center px-1" data-id="element-2740" data-mp="30jd5759dnnxv">
      <ShieldCheck className="w-5 h-5 text-white/90 mb-0.5" data-id="element-2741" data-mp="34jx4aedih1mn" />
      <span className="text-[7px] font-bold uppercase tracking-[0.12em] leading-tight text-white/80" data-id="element-2742" data-mp="27upjx9omoykb">
        {label}
      </span>
    </div>;
}
export function ProductInfoPanels({
  product
}: {
  product: Product;
}) {
  const [descOpen, setDescOpen] = useState(true);
  return <section className="max-w-7xl mx-auto px-6 mt-16 md:mt-20" data-id="element-2743" data-mp="2gxiafapzl693">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-2744" data-mp="2lva161ewambp">
        {/* LEFT — Ingredient Testing & Quality */}
        <div className="bg-[#16263A] text-white rounded-2xl p-8 md:p-10 flex flex-col" data-id="element-2745" data-mp="3sa1a8se69dgt">
          <h3 className="text-2xl font-bold mb-4" data-id="element-2746" data-mp="12yj20yc376l">
            Ingredient Testing & Quality
          </h3>
          <p className="text-sm md:text-[15px] leading-relaxed text-white/85 mb-8" data-id="element-2747" data-mp="mii2ttdbdc8y">
            Our products are made with raw materials sourced by suppliers that
            test each ingredient before release in an ISO: 17025 Certified Lab.
            Sourcing is done from manufacturers registered and inspected by the
            FDA. Our suppliers fully test every batch of sourced raw material
            using good manufacturing practices (cGMP). Internationally sourced
            ingredients undergo FTIR purity testing, microbiology contamination
            testing, ICP-MS heavy metal testing (Hg, As, Pb, Cd), and assay
            testing when applicable, after passing through U.S. Customs and FDA
            inspection.
          </p>
        </div>

        {/* RIGHT — Description */}
        <div className="bg-[#F9F9F9] border border-[#E5E5E5] rounded-2xl p-8 md:p-10" data-id="element-2748" data-mp="3g0rgp7y814n0">
          <div className="flex items-center justify-between mb-5" data-id="element-2749" data-mp="3c0hd21xwiqbb">
            <h3 className="text-base font-bold text-[#1F1F1F]" data-id="element-2750" data-mp="31ekp4zzzuu4d">Description</h3>
            <button type="button" onClick={() => setDescOpen(v => !v)} aria-expanded={descOpen} aria-label={descOpen ? 'Collapse description' : 'Expand description'} className="text-[#9A9A90] hover:text-[#1F1F1F] transition-colors" data-id="element-2751" data-mp="36dox5nb6mlt4">
              {descOpen ? <X className="w-5 h-5" data-id="element-2752" data-mp="3l57a1c8qw089" /> : <Plus className="w-5 h-5" data-id="element-2753" data-mp="3p350eie94sd8" />}
            </button>
          </div>

          {descOpen && <div className="space-y-4 text-sm md:text-[15px] leading-relaxed text-[#5A5A5A] mb-2" data-id="element-2754" data-mp="3bcrt8i96phoy">
              <p data-id="element-2755" data-mp="3ga9zu1zqbkts">{product.shortDescription}</p>
              <p data-id="element-2756" data-mp="7vronrehrp5y">{product.whyEffective}</p>
            </div>}

          <details className="group border-t border-[#E5E5E5] mt-4" data-id="element-2757" data-mp="7ugos2o631k4">
            <summary className="cursor-pointer list-none flex items-center justify-between py-5 text-base font-medium text-[#1F1F1F]" data-id="element-2758" data-mp="cocgindu7s6u">
              Nutrition &amp; Supplement Facts
              <Plus className="w-5 h-5 text-[#9A9A90] transition-transform group-open:rotate-45" data-id="element-2759" data-mp="hzgle9fk910d" />
            </summary>
            <div className="text-sm text-[#5A5A5A] leading-relaxed pb-6 space-y-2" data-id="element-2760" data-mp="vqv229lzwq49">
              <p data-id="element-2761" data-mp="qt3cvncqji3r">
                Serving size: {product.dose} {product.doseUnit}.
              </p>
              <p data-id="element-2762" data-mp="33hdaysgb0v8">
                Made with clean, bioavailable ingredients — no artificial
                sweeteners, coloring, or preservatives. Full supplement facts
                panel is printed on the product label.
              </p>
            </div>
          </details>

          <details className="group border-t border-[#E5E5E5]" data-id="element-2763" data-mp="810pzu9i35l2">
            <summary className="cursor-pointer list-none flex items-center justify-between py-5 text-base font-medium text-[#1F1F1F]" data-id="element-2764" data-mp="1og20l8lg9fpi">
              Shipping &amp; Returns
              <Plus className="w-5 h-5 text-[#9A9A90] transition-transform group-open:rotate-45" data-id="element-2765" data-mp="1jjbk4k5qgi3k" />
            </summary>
            <div className="text-sm text-[#5A5A5A] leading-relaxed pb-6 space-y-2" data-id="element-2766" data-mp="3u4kvib6uxvfo">
              <p data-id="element-2767" data-mp="3u6fh7rpydrkt">
                Orders ship within 1–2 business days. Standard delivery arrives
                in 3–5 business days.
              </p>
              <p data-id="element-2768" data-mp="70xvi0kbkxar">
                Not satisfied? Return any unopened product within 30 days for a
                full refund.
              </p>
            </div>
          </details>
        </div>
      </div>
    </section>;
}